module.exports = __webpack_public_path__ + "static/portfolio-6-41ffc7250464cdce33dc1ff6da42ba47.jpg";